import React, { useState } from "react";

function HomeVideo() {
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = (e) => {
    e.preventDefault(); // 🔥 stop redirect
    setIsOpen(true);
  };

  return (
    <>
      <section className="video-area faq_section home_four pt_150">
        <div className="container">
          <div className="row align-items-center">
            {/* Video Box */}
            <div className="col-xl-6 col-lg-6 col-md-12">
              <div
                className="video_box mr_30"
                data-aos="fade-right"
                data-aos-easing="linear"
                data-aos-duration="500"
                style={{
                  backgroundImage: "url(/images/background/Video-box-img.png)",
                }}
              >
                <a
                  href="/images/brainfintech.mp4"
                  className="lightbox-image"
                  data-caption=""
                  onClick={handleClick} // ✅ only change
                >
                  <div className="icon_box">
                    <i class="fa-solid fa-play"></i>
                  </div>
                </a>
              </div>
            </div>

            {/* Text Content */}
            <div className="col-xl-6 col-lg-6 col-md-12">
              <div
                className="inner_box ml_30"
                data-aos="fade-left"
                data-aos-easing="linear"
                data-aos-duration="500"
                data-aos-delay="200"
              >
                <div className="section_title">
                  <h2>Explore Our Premium Content</h2>
                  <p>
                    Discover exclusive insights and tutorials in this video.
                    Click play to start and pause anytime to follow along at
                    your own pace.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ✅ Modal (new added) */}
      {isOpen && (
        <div
          onClick={() => setIsOpen(false)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.8)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              position: "relative",
              width: "100%",
              maxWidth: "1200px",
            }}
          >
            {/* Close Button */}
            <button
              onClick={() => setIsOpen(false)}
              style={{
                position: "absolute",
                top: "-40px",
                right: "0",
                background: "#fff",
                border: "none",
                padding: "8px 12px",
                cursor: "pointer",
              }}
            >
              ✖
            </button>

            {/* Video */}
            <video
              src="/images/brainfintech.mp4"
              controls
              autoPlay
              style={{ width: "100%" }}
            />
          </div>
        </div>
      )}
    </>
  );
}

export default HomeVideo;
